import ApiService from '@/api/ApiService'
import { BookingSignalPhone } from '@/shared/models/BookingSignalPhone'
import proxy from '@/shared/proxy'

const BookingSignalService = {

  UpdatePhoneHash (request: BookingSignalPhone) {
    return ApiService.putAsync(proxy.Hotelv1, 'BookingSignal/UpdatePhoneHash', request)
  }
}
export default BookingSignalService
